import { Sparkles } from "lucide-react";

interface SearchResultProps {
  title?: string;
  response?: string;
}

function SearchTextGenerationSkeleton() {
  const lineWidths = ["90%", "75%", "82%", "65%", "50%", "77%", "85%", "59%"];

  return (
    <div className={`px-5 py-4 w-full box-border`}>
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-5 h-5 text-highlight" />
        <p className="text-sm font-medium text-highlight">
          Gerando resposta...
        </p>
      </div>

      <div className="flex flex-col gap-3">
        {lineWidths.map((width, i) => (
          <div
            key={i}
            className="h-4 rounded-full bg-gradient-to-r from-orange-400/60 via-orange-400/30 to-orange-400/20 animate-pulse"
            style={{ width }}
          />
        ))}
      </div>
    </div>
  );
}

export function SearchTextGeneration({ title, response }: SearchResultProps) {
  if (!response) return <SearchTextGenerationSkeleton />;

  return (
    <div className={`px-5 py-4 w-full box-border`}>
      <div className="flex items-center gap-2 mb-4">
        <Sparkles className="w-5 h-5 text-highlight" />
        <p className="text-sm font-medium text-highlight">{title}</p>
      </div>

      <div
        className={`text-sm leading-[1.5] text-primary-text-secondary`}
        dangerouslySetInnerHTML={{ __html: response }}
      />
    </div>
  );
}
